import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/style/index.scss' // global css
import '@/style/normalize.css' // global css
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

        
const app = createApp(App)
app.use(router)
app.use(ElementPlus)
app.mount('#app')

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}